import { Helmet } from "react-helmet-async";
import Screen from "../Layouts/Screen/Screen";
import ItemList from "../../components/ItemList/ItemList";
import { Archive, Award, Bell, DollarSign, FileText, Star, UserMinus, Users, UserX } from "react-feather";
import { Accessibility, PersonStanding } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { useMessage } from "../../global-components/src";
import axios from "axios";
import { useAuth } from "../../global-components/src";
import { errorMessage } from "../../utils/TextManagerTwo";
import Spinner from "../../global-components/src/components/spinner/spiner";
import { Ban } from "../../types";
import UserSearch from "./SearchScreen/User/User";
import { PACOCA_API_URL } from "../../global-components/src/utils/vars";
import { UserSearchLoadin } from "./SearchScreen/User/UserSearchLoading";

const UserBlocks = () => {
    const observerRef = useRef<IntersectionObserver | null>(null);
    const endOfListRef = useRef<HTMLDivElement | null>(null);
    const [bans, setBans] = useState<Ban[] | null>(null);
    const closeRef = useRef<HTMLButtonElement | null>(null);
    const { setMessage } = useMessage();
    const [loading, setLoading] = useState(false);
    const [end, setEnd] = useState(false);
    const [page, setPage] = useState(() => { return 1; });
    const { token } = useAuth();

    const loadData = async (newPage?: number) => {
        const currentPage = newPage ?? page + 1; // Usa newPage se fornecido, senão incrementa
        const url = PACOCA_API_URL + `/users/blocks?page=${currentPage}`;

        if (loading || end) return;
        setLoading(true);

        try {
            const response = await axios.get(url, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });

            const data = response.data;

            if (data.bans.length > 0) {
                setBans((prevData) => [...(prevData || []), ...data.bans]);
            } else {
                setEnd(true);
            }

        } catch (err: any) {
            const type = err?.response?.data?.type_message || "error";
            const messageError = errorMessage(err)
            setMessage(messageError, type)
            console.error('Erro:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadData(page);
    }, [page]);

    return (
        <>
            <Screen paddingTopTitle={true} title="Usuários Bloqueados">
                <Helmet>
                    <title>Usuários Bloqueados</title>
                    <meta name="description" content="Veja os usuários que você bloqueou" />
                    <meta name="keywords" content="bloqueados, usuarios bloqueados, banidos, rede social, fazer amigos, conexões online, comunidade digital, rede social brasileira, criar perfil online, compartilhar momentos" />
                    <meta name="author" content="Paçoca Inc." />
                    <meta property="og:title" content="Paçoca - Usuários Bloqueados" />
                    <meta property="og:description" content="Veja os usuários que você bloqueou" />
                    <meta property="og:image" content="/img/link-preview.png?v=1" />
                    <meta property="og:url" content={window.location.href} />
                    <meta property="og:type" content="website" />
                    <meta name="twitter:card" content="summary_large_image" />
                    <meta name="twitter:title" content="Paçoca - Usuários Bloqueados" />
                    <meta name="twitter:description" content="Veja os usuários que você bloqueou" />
                    <meta name="twitter:image" content="/img/link-preview.png?v=1" />
                </Helmet>

                <UserSearchLoadin loading={loading} />

                {!loading && !bans?.length ? (
                    <div className="user-select-none row row-empty-comment">
                        <span className="span-empty">
                            <UserMinus className="icon-empty" />
                            <h3 className="w-100 text-center">Nenhum usuário bloqueado</h3>
                        </span>
                    </div>
                ) : null}

                {bans?.map((ban, index) => {
                    return (
                        <UserSearch hideFollowUser key={index} user={ban?.user} />
                    );
                })}

                <p ref={endOfListRef}></p>
            </Screen>
        </>
    );
};

export default UserBlocks;